import { Button, Fade, Tooltip } from '@material-ui/core'
import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'

import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import './ProductCard.css'
import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import Bidding from '@/custom/components/molecules/Bidding/BiddingItem'
import ProxyBidding from '@/custom/components/molecules/Bidding/ProxyBidding'

import Buynow from '@/custom/components/molecules/Buynow/BuynowItem'
import { dateFormatFront } from '@/custom/common/components'
import { handleRedirectInternal, currencyFormat } from '@/custom/common/components'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
// import Timer from '@/product/common/timer'
import Timer from '@/custom/common/timer'
import { FALLBACK_IMAGE } from '@/utils'
import SignContext from '@/custom/context/signContext'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import CustomReverseBidding from '@/custom/components/molecules/Reverse/Bidding/CustomReverseBidding'
const isValidHttpUrl = (string) => {
    let url

    try {
        url = new URL(string)
    } catch (err) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}
const Grid = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { setBidHistoryValue } = commonContext
    const { user, isAuthenticated } = authContext
    const { configVariables } = customCommonContext
    const { loginPopup, handleLoginPopup, kycPopup, handleKycPopup, handleBusign } =
        useContext(SignContext)
    const [product, setProduct] = useState()
    const history = useHistory()

    const auctionDetails = props.auctionDetails
    console.log(auctionDetails, 'hhhhhhhhhhh')
    useEffect(() => {
        setProduct(props.data)
    }, [props.data])
    const isPrivateCheck = (details, auction) => {
        let result = true
        if (user && user.id > 0 && user?.initial_bu_status == 2) {
            //result = true
            if (
                auction &&
                auction?.custom_bu_sign_document &&
                auction?.bidder_undertaking_status != 1
            ) {
                return true
            } else if (details?.entire_auction_access) {
                return false

                // if (details.selectedviewer?.split(',')?.includes(user.id?.toString())) {
                //     return false
                // } else {
                //     return true
                // }
            } else if (details?.entire_project_access) {
                return false
            } else {
                return true
            }
        }
        return result
    }

    return (
        <Fade in={true} timeout={600}>
            <div className="productCardGrid">
                {product ? (
                    <>
                        <div>
                            <div className="pcgImg">
                                <FavouriteCheckbox
                                    watchlisted={product.watchlistid}
                                    project_id={product.id}
                                />
                                <img
                                    className="cursorDecoy"
                                    onClick={props.drawerHandler}
                                    src={
                                        product.avatar && isValidHttpUrl(product.avatar)
                                            ? product.avatar
                                            : `${global.site_url}/uploads/product/${product.avatar}`
                                    }
                                    onError={(e) => FALLBACK_IMAGE(e)}
                                    alt={product.title}
                                />
                                {isAuthenticated && (
                                    <>
                                        {product.auctiontype != 'sealed' ||
                                        product.sub_auctiontype == 'status' ? (
                                            <>
                                                {product.bidtopstatus === 'outbid' && (
                                                    <h4 className="productWinningStatus outbid">
                                                        {(product.sub_auctiontype == 'status'
                                                            ? product.current_bid
                                                            : product.wprice) < product.rprice
                                                            ? 'Reserve not met'
                                                            : 'Outbid'}
                                                    </h4>
                                                )}
                                                {product.bidtopstatus === 'winner' && (
                                                    <h4 className="productWinningStatus winning">
                                                        {(product.sub_auctiontype == 'status'
                                                            ? product.current_bid
                                                            : product.wprice) < product.rprice
                                                            ? 'Reserve not met'
                                                            : 'Winning'}
                                                    </h4>
                                                )}
                                                {product.bidtopstatus === 'won' && (
                                                    <h4 className="productWinningStatus won">
                                                        {'Highest Bidder'}
                                                    </h4>
                                                )}
                                                {product.bidtopstatus === 'lost' && (
                                                    <h4 className="productWinningStatus lost">
                                                        {'Lost'}
                                                    </h4>
                                                )}

                                                {/* {(product.bidtopstatus === 'outbid' ||
                                        product.bidtopstatus === 'winner') &&
                                        product.wprice <= product.rprice && (
                                            <>
                                                <Tooltip title="Reserve price not met">
                                                    <span className="material-icons reserveNotMet">
                                                        lock_open
                                                    </span>
                                                </Tooltip>
                                            </>
                                        )} */}
                                            </>
                                        ) : null}
                                    </>
                                )}
                            </div>
                            <h2
                                className="gridProdTitle"
                                style={{ 'font-weight': '700' }}
                                onClick={props.drawerHandler}
                            >
                                Lot Number - {product.lotnumber}
                            </h2>
                            <h2 className="gridProdTitle" onClick={props.drawerHandler}>
                                {product.title}
                            </h2>
                            <div className="gridLotDetails d-flex justify-content-start align-items-center">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: product.desc_proc,
                                    }}
                                ></p>
                            </div>

                            {product.market_status === 'open' ? (
                                <div className="gridTimer">
                                    <div className="grdTmrIcon">
                                        <img src="/assets/svg/timer.svg" />
                                        <hr />
                                    </div>
                                    <p>
                                        {product.date_closed ? (
                                            <Timer
                                                withText={1}
                                                date_added={product.date_added}
                                                date_closed={product.date_closed}
                                            ></Timer>
                                        ) : null}
                                    </p>
                                </div>
                            ) : (
                                <div className="gridTimer d-flex justify-content-center align-items-center">
                                    <h6 className="m-0">{'Closed on'}:</h6>
                                    <p className="d-flex align-items-center">
                                        {dateFormatFront(product.date_closed)}
                                    </p>
                                </div>
                            )}

                            {/* <div className="gridBidInfo d-flex justify-content-between align-items-center">
                            <h6>{t('auction')} id:</h6>
                            <p>
                                <span>{`#${product.auctionid}`}</span>
                            </p>
                        </div> */}

                            <>
                                {' '}
                                {product.market_status === 'open' ? (
                                    <>
                                        <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                            <h6>Start Price: </h6>
                                            {product.auction ? (
                                                <>
                                                    <p className="d-flex justify-content-between align-items-center">
                                                        <span>
                                                            {currencyFormat(product.sprice)}
                                                        </span>{' '}
                                                        {!isPrivateCheck(product, auctionDetails) &&
                                                        isAuthenticated &&
                                                        product.bid_or_not ? (
                                                            <>
                                                                {' '}
                                                                <span className="gridDivider">
                                                                    |
                                                                </span>
                                                                <span
                                                                    className="cursorDecoy"
                                                                    onClick={() =>
                                                                        setBidHistoryValue(
                                                                            product.id,
                                                                        )
                                                                    }
                                                                >
                                                                    {product.auctiontype == 'sealed'
                                                                        ? 'View Offers'
                                                                        : 'View Bids'}
                                                                </span>
                                                            </>
                                                        ) : null}
                                                    </p>
                                                </>
                                            ) : (
                                                <p className="notAvailable">
                                                    <span>{'Not available'}</span>
                                                </p>
                                            )}
                                        </div>
                                        {product.qty ? (
                                            <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                <h6>Qty: </h6>

                                                <p className="d-flex justify-content-between align-items-center">
                                                    <span>{product.qty}</span>
                                                </p>
                                            </div>
                                        ) : null}{' '}
                                        {product.unitofmessurement ? (
                                            <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                <h6>UOM: </h6>

                                                <p className="d-flex justify-content-between align-items-center">
                                                    <span>{product.unitofmessurement}</span>
                                                </p>
                                            </div>
                                        ) : null}
                                        {product.auctiontype != 'sealed' ? (
                                            <div>
                                                {product.bid_limit ? (
                                                    user?.initial_bu_status == 2 ? (
                                                        !isPrivateCheck(product, auctionDetails) ? (
                                                            <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                                <h6>My Current Bid: </h6>
                                                                {product.auction ? (
                                                                    <p className="d-flex justify-content-between align-items-center">
                                                                        <span>
                                                                            {currencyFormat(
                                                                                product.biddercurrentbid,
                                                                            )}
                                                                        </span>
                                                                        {/* <span className="gridDivider">|</span>
                                            <span
                                                className="cursorDecoy"
                                                onClick={() => setBidHistoryValue(product.id)}
                                            >
                                                {product.bid_count} {'Bids'}
                                            </span> */}
                                                                    </p>
                                                                ) : (
                                                                    <p className="notAvailable">
                                                                        <span>
                                                                            {'Not available'}
                                                                        </span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                        ) : null
                                                    ) : null
                                                ) : (
                                                    <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                        {user?.initial_bu_status == 2 ? (
                                                            !isPrivateCheck(
                                                                product,
                                                                auctionDetails,
                                                            ) ? (
                                                                <>
                                                                    <h6>{product.cbidtext}: </h6>
                                                                    {product.auction ? (
                                                                        <p className="d-flex justify-content-between align-items-center">
                                                                            <span>
                                                                                {currencyFormat(
                                                                                    product.wprice,
                                                                                )}
                                                                            </span>
                                                                            {/* <span className="gridDivider">|</span>
                                            <span
                                                className="cursorDecoy"
                                                onClick={() => setBidHistoryValue(product.id)}
                                            >
                                                {product.bid_count} {'Bids'}
                                            </span> */}
                                                                        </p>
                                                                    ) : (
                                                                        <p className="notAvailable">
                                                                            <span>
                                                                                {'Not available'}
                                                                            </span>
                                                                        </p>
                                                                    )}
                                                                </>
                                                            ) : null
                                                        ) : null}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                    {product.auctiontype == 'sealed' ? (
                                                        <h6>My Offer: </h6>
                                                    ) : (
                                                        <h6>My Bid: </h6>
                                                    )}

                                                    {product.current_bid ? (
                                                        <p className="d-flex justify-content-between align-items-center">
                                                            <span>
                                                                {currencyFormat(
                                                                    product.bid_or_not
                                                                        ? product.current_bid
                                                                        : 0,
                                                                )}
                                                            </span>
                                                            <span
                                                                className="cursorDecoy"
                                                                onClick={() =>
                                                                    setBidHistoryValue(product.id)
                                                                }
                                                            ></span>
                                                        </p>
                                                    ) : (
                                                        <p className="notAvailable">
                                                            <span>{currencyFormat(0)}</span>
                                                        </p>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                        {product.auctiontype != 'sealed' ? (
                                            <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                {user?.initial_bu_status == 2 ? (
                                                    !isPrivateCheck(product, auctionDetails) ? (
                                                        <>
                                                            {product.next_bid > 0 &&
                                                            product.bid_limit_auction == 0 ? (
                                                                <h6>Next Bids: </h6>
                                                            ) : null}
                                                            {product.auction ? (
                                                                <p className="d-flex justify-content-between align-items-center">
                                                                    {product.next_bid > 0 &&
                                                                    product.bid_limit_auction ==
                                                                        0 ? (
                                                                        <span>
                                                                            {currencyFormat(
                                                                                product.next_bid,
                                                                            )}
                                                                        </span>
                                                                    ) : null}
                                                                    {/* {product.bid_limit_auction > 0 ? (
                                                        <>
                                                        
                                                            <span
                                                                className="cursorDecoy"
                                                                onClick={() =>
                                                                    setBidHistoryValue(product.id)
                                                                }
                                                            >
                                                                {'View Bids'}
                                                            </span>
                                                        </>
                                                    ) : null} */}
                                                                </p>
                                                            ) : (
                                                                <p className="notAvailable">
                                                                    <span>{'Not available'}</span>
                                                                </p>
                                                            )}
                                                        </>
                                                    ) : null
                                                ) : null}
                                            </div>
                                        ) : null}
                                        {/* <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                            <h6>{'Buy Now Price'}:</h6>
                                            {product.buynow && product.wprice < product.bprice ? (
                                                <p className="d-flex justify-content-between align-items-center">
                                                    <span>
                                                        {currencyFormat(product.bprice * product.qty)}
                                                    </span>
                                                </p>
                                            ) : (
                                                <p className="notAvailable">
                                                    <span>{'Not Available'}</span>
                                                </p>
                                            )}
                                        </div> */}
                                    </>
                                ) : (
                                    <>
                                        {product.auctiontype != 'sealed' ? (
                                            <>
                                                <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                    <h6>{product.cbidtext}: </h6>
                                                    <p className="d-flex justify-content-between align-items-center">
                                                        <span>
                                                            {currencyFormat(product.buynowamount)}
                                                        </span>
                                                    </p>
                                                </div>
                                                {/* <div className="gridBidInfo d-flex justify-content-between align-items-center"></div> */}
                                            </>
                                        ) : null}
                                    </>
                                )}
                                {console.log(product.current_bid, 'product.sub_auctiontype')}
                                {isAuthenticated && product.bidtopstatus ? (
                                    <>
                                        {product.auctiontype != 'sealed' ||
                                        product.sub_auctiontype == 'status' ? (
                                            <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                {product.bidtopstatus ? <h6>Status : </h6> : null}
                                                {product.bidtopstatus === 'outbid' && (
                                                    <h6 className="productWinningStatus2 outbid">
                                                        {(product.sub_auctiontype == 'status'
                                                            ? product.current_bid
                                                            : product.wprice) < product.rprice
                                                            ? 'Reserve not met'
                                                            : 'Outbid'}
                                                    </h6>
                                                )}
                                                {product.bidtopstatus === 'winner' && (
                                                    <h6 className=" productWinningStatus2 winning">
                                                        {(product.sub_auctiontype == 'status'
                                                            ? product.current_bid
                                                            : product.wprice) < product.rprice
                                                            ? 'Reserve not met'
                                                            : 'Winning'}
                                                    </h6>
                                                )}
                                                {product.bidtopstatus === 'won' && (
                                                    <h6 className="productWinningStatus2 won">
                                                        {'Highest Bidder'}
                                                    </h6>
                                                )}
                                                {product.bidtopstatus === 'lost' && (
                                                    <h6 className="productWinningStatus2 lost">
                                                        {'Lost'}
                                                    </h6>
                                                )}
                                                {product.bidtopstatus !== 'outbid' ||
                                                    product.bidtopstatus !== 'Highest Bidder' ||
                                                    product.bidtopstatus !== 'Winning' ||
                                                    product.bidtopstatus !== 'lost' ||
                                                    product.bidtopstatus !== 'won' ||
                                                    (product.bidtopstatus !== 'winner' && '-')}
                                            </div>
                                        ) : null}
                                    </>
                                ) : null}
                            </>
                        </div>
                        {/* {isAuthenticated ? null : null} */}
                        <div className="bidWrapper">
                            {!isPrivateCheck(product, auctionDetails) &&
                            product.market_status == 'open' ? (
                                <>
                                    {props.from === 'dashboard' &&
                                    (props.action === 'won' || props.action === 'buynow') &&
                                    product.buynowed &&
                                    product.buynowed === user.id ? (
                                        <div className="actionAfterWin">
                                            {parseInt(product.buynowpaid, 10) === 1 ? (
                                                <>
                                                    <SecondaryButton
                                                        id="invoice_viewed"
                                                        label={'View invoice'}
                                                        btnSize="small"
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                `invoice/${product.common_invoice}`,
                                                            )
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    {/* <PrimaryButton
                                            id="make_pay_grid"
                                            label={'Make payment'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `checkout/invoice/${product.common_invoice}`,
                                                )
                                            }
                                        /> */}
                                                </>
                                            )}
                                        </div>
                                    ) : product.market_status === 'open' &&
                                      !product.future_active ? (
                                        <>
                                            {product.auction ? (
                                                <div className="gridBidBox">
                                                    {product.bid_limit_auction > 0 ? (
                                                        <div style={{ display: 'flex' }}>
                                                            {product.auctiontype === 'sealed' ? (
                                                                <h6>Offers Remaining :</h6>
                                                            ) : (
                                                                <h6>Bids Remaining :</h6>
                                                            )}{' '}
                                                            <h6>
                                                                {parseInt(product.bid_limit, 10) -
                                                                    product.hardbid_count}
                                                            </h6>
                                                        </div>
                                                    ) : null}
                                                    {product.auctiontype == 'reverse' ? (
                                                        <>
                                                            {product.bid_limit_auction > 0 ? (
                                                                <div className="mt-2">
                                                                    <ReverseBidding
                                                                        data={product}
                                                                        type="hard"
                                                                        disabled={
                                                                            product.sprice <= 0
                                                                                ? true
                                                                                : product.bid_limit_auction >
                                                                                      0 &&
                                                                                  parseInt(
                                                                                      product.bid_limit,
                                                                                      10,
                                                                                  ) -
                                                                                      product.hardbid_count ==
                                                                                      0
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {' '}
                                                                    <CustomReverseBidding
                                                                        disabled={
                                                                            product.sprice <= 0
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        data={product}
                                                                        type="hard"
                                                                    />
                                                                    <div className="revBiddinCnt">
                                                                        <ReverseBidding
                                                                            data={product}
                                                                            type="proxy"
                                                                            disabled={
                                                                                product.sprice <= 0
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    ) : product.custom_auctionlot_bid_type ? (
                                                        <Bidding
                                                            disabled={
                                                                product.sprice <= 0 ? true : false
                                                            }
                                                            data={product}
                                                            type={`${product.custom_auctionlot_bid_type}`}
                                                        />
                                                    ) : product.auctiontype === 'sealed' ? (
                                                        product.sub_auctiontype === 'status' ? (
                                                            <>
                                                                {product.bid_limit_auction >
                                                                0 ? null : (
                                                                    <Bidding
                                                                        data={product}
                                                                        type="sealed"
                                                                        disabled={
                                                                            product.sprice <= 0
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                )}

                                                                <ProxyBidding
                                                                    data={product}
                                                                    type="sealed"
                                                                    disabled={
                                                                        product.sprice <= 0
                                                                            ? true
                                                                            : product.bid_limit_auction >
                                                                                  0 &&
                                                                              parseInt(
                                                                                  product.bid_limit,
                                                                                  10,
                                                                              ) -
                                                                                  product.hardbid_count ==
                                                                                  0
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                            </>
                                                        ) : (
                                                            <ProxyBidding
                                                                data={product}
                                                                type="sealed"
                                                                disabled={
                                                                    product.sprice <= 0
                                                                        ? true
                                                                        : product.bid_limit_auction >
                                                                              0 &&
                                                                          parseInt(
                                                                              product.bid_limit,
                                                                              10,
                                                                          ) -
                                                                              product.hardbid_count ==
                                                                              0
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                        )
                                                    ) : (
                                                        <>
                                                            <Bidding
                                                                data={product}
                                                                type={'hard'}
                                                                disabled={
                                                                    product.sprice <= 0
                                                                        ? true
                                                                        : product.bid_limit_auction >
                                                                              0 &&
                                                                          parseInt(
                                                                              product.bid_limit,
                                                                              10,
                                                                          ) -
                                                                              product.hardbid_count ==
                                                                              0
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            {isAuthenticated &&
                                                            !product.bid_limit_auction ? (
                                                                <div className="revBiddinCnt">
                                                                    <ProxyBidding
                                                                        data={product}
                                                                        type="proxy"
                                                                        disabled={
                                                                            product.sprice <= 0
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="gridBidBox">
                                                    <Buynow
                                                        data={product}
                                                        editQuantity={true}
                                                        isOnlyBuynow={
                                                            product.auction === 0 ? true : false
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </>
                                    ) : product.buynowed && product.buynowed === user.id ? (
                                        <>
                                            {parseInt(product.buynowpaid, 10) === 1 ? (
                                                <div className="actionAfterWin">
                                                    <SecondaryButton
                                                        id="invoice_viewed_grid"
                                                        label={'View invoice'}
                                                        btnSize="small"
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                `invoice/${product.common_invoice}`,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    {/* <PrimaryButton
                                            id="make_pay_grid"
                                            label={'Make payment'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `checkout/invoice/${product.common_invoice}`,
                                                )
                                            }
                                        /> */}
                                                </>
                                            )}
                                        </>
                                    ) : product.market_status === 'open' ? (
                                        <div className="gridBidBox"></div>
                                    ) : null}
                                </>
                            ) : product.market_status == 'closed' ||
                              product.market_status == 'sold' ||
                              product.market_status == 'unsold' ? (
                                <>
                                    {' '}
                                    <PrimaryButton
                                        id="make_pay_grid"
                                        label={'Auction Closed'}
                                        btnSize="small"
                                        // onClick={() =>
                                        //     handleRedirectInternal(
                                        //         history,
                                        //         `checkout/invoice/${product.common_invoice}`,
                                        //     )
                                        // }
                                    />
                                </>
                            ) : (
                                <>
                                    {' '}
                                    <PrimaryButton
                                        id="make_pay_grid"
                                        label={'No Bidding Rights'}
                                        btnSize="small"
                                        onClick={() => {
                                            if (!isAuthenticated) {
                                                handleLoginPopup()
                                            } else if (user && !user.is_kyc_done) {
                                                handleKycPopup()
                                            }
                                        }}
                                    />
                                </>
                            )}

                            <div className="moreInfo text-center mt-2">
                                <Button id="view_more_info" onClick={props.drawerHandler}>
                                    View more info
                                    <span
                                        className={`material-icons ${
                                            document.body.dir === 'rtl' && 'rtl'
                                        }`}
                                    >
                                        arrow_right_alt
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </Fade>
    )
}

export default Grid
